export { default } from './features-display';
export { default as FeaturesDisplayWidget } from './features-display-widget';



// WEBPACK FOOTER //
// ./app/common/components/features-display/index.js